export const PLANS = [
  {
    id: 'starter',
    name: 'Starter',
    placeholder: 'Test the water',
    price: {
      monthly: 23,
      annual: 12,
    },
    trial: {
      frequency: 'annual',
      coupon: 'FREE15',
    },
    // name: 'Essentials',
    // promo: {
    //   id: 'app-sumo',
    //   price: 59,
    //   frequency: 'lifetime access',
    //   saveinfo: <>Limited time offer<br/>via AppSumo</>,
    //   link: 'http://appsumo.8odi.net/WDDbLZ',
    // },
  },
  {
    id: 'plus',
    name: 'Plus',
    placeholder: 'Build an audience',
    price: {
      monthly: 59,
      annual: 47,
    },
    trial: {
      frequency: 'annual',
      coupon: 'FREE15',
    },
  },
  {
    id: 'pro',
    name: 'Pro',
    placeholder: 'Make it a career',
    price: {
      monthly: 119,
      annual: 97,
    },
    trial: {
      frequency: 'annual',
      coupon: 'FREE15',
    },
    highlight: true,
  },
  {
    id: 'platinum',
    name: 'Platinum',
    placeholder: 'Build an empire',
    price: {
      monthly: 469,
      annual: 367,
    },
  },
];
